import { render } from "./Default.vue?vue&type=template&id=1b57393b&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import "./Default.vue?vue&type=style&index=0&id=1b57393b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b57393b"],['__file',"src/components/layouts/Default.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b57393b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b57393b', __exports__)) {
    api.reload('1b57393b', __exports__)
  }
  
  module.hot.accept("./Default.vue?vue&type=template&id=1b57393b&scoped=true", () => {
    api.rerender('1b57393b', render)
  })

}


export default __exports__